export default "__VITE_ASSET__jSXe7Jfh__"